import 'bootstrap/dist/css/bootstrap.min.css';
import {Route, Routes, HashRouter} from 'react-router-dom';
import './App.css';
import Auth from './Auth';
import SignUp from './SignUp';
import WatchlistScreen from './WatchlistScreen';
import SubExpired from './SubExpired';
import {Payment} from './Payment';
import TopListScreen from './TopListScreen';
import {useEffect} from 'react';
import {getSubscriptionsList} from './api/GetSubscriptionsList';

function App() {
  useEffect(() => {
    getSubscriptionsList();
  }, []);

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Auth />} />
        <Route path="/subexpired" element={<SubExpired />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/watchlist" element={<WatchlistScreen />} />
        <Route path="/toplist" element={<TopListScreen />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
